import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { BackdropSuspense } from '../../components/backdrop-suspense';
import { ErrorFallback } from '../../components/error-fallback/error-fallback';
import { Navigation } from '../../components/navigation';
import { ROUTES } from '../../routes/routes';

export const withRouteWrapper = (Component: React.FC, navigation?: boolean) => (
  <ErrorBoundary
    fallbackRender={({ error, resetErrorBoundary }) => (
      <ErrorFallback error={error} resetErrorBoundary={resetErrorBoundary} />
    )}
  >
    {navigation && <Navigation />}
    <Suspense fallback={<BackdropSuspense />}>
      <Component />
    </Suspense>
  </ErrorBoundary>
);

export const relativeAddBluetoothPath = (path: string) => {
  return path.replace(`${ROUTES.DeviceAddBluetooth()}/`, '');
};
